/**
 * @generated SignedSource<<579607b20a0aa2dd1ee4dc3b39e30d7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookingWizardUIHeaderFragment$data = {
  readonly logoImage: {
    readonly publicId: string;
  } | null | undefined;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"ClubLogo_Club">;
  readonly " $fragmentType": "BookingWizardUIHeaderFragment";
};
export type BookingWizardUIHeaderFragment$key = {
  readonly " $data"?: BookingWizardUIHeaderFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookingWizardUIHeaderFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookingWizardUIHeaderFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ClubLogo_Club"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "logoImage",
      "plural": false,
      "selections": [
        {
          "alias": "publicId",
          "args": null,
          "kind": "ScalarField",
          "name": "renderingKey",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "c4ac4e26c0dabdef048f33a5d819f857";

export default node;
